import { render, staticRenderFns } from "./TagTable.vue?vue&type=template&id=de9b58fa&"
import script from "./TagTable.vue?vue&type=script&lang=js&"
export * from "./TagTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports